export const actor = {
  name: '夏目彩春',
  nameEn: 'Natsume Ayaharu',
  tagline: '以克制与张力并存的表演，成为当代最具代表性的实力派女演员之一。',
  portrait:
    'https://readdy.ai/api/search-image?query=elegant%20editorial%20portrait%20of%20an%20asian%20actress%20with%20calm%20confident%20expression%2C%20soft%20directional%20studio%20lighting%2C%20muted%20charcoal%20and%20warm%20cream%20tones%2C%20minimal%20clean%20background%2C%20high%20fashion%20magazine%20photography%2C%20subtle%20film%20grain%2C%20refined%20composition&width=800&height=1000&seq=natsume-portrait-main&orientation=portrait',
  info: [
    { label: '姓名', value: '夏目彩春（Natsume Ayaharu）' },
    { label: '出生日期', value: '1996年3月14日' },
    { label: '国籍', value: '日本' },
    { label: '身高', value: '168 cm' },
    { label: '出道年份', value: '2015年' },
    { label: '代表成就', value: '国际电影节最佳女主角提名、年度最佳影片主演' },
    { label: '擅长题材', value: '剧情、悬疑、都市、古装' },
    { label: '经纪公司', value: 'Mirai 艺能事务所' },
  ],
  bio: [
    '夏目彩春于2015年以电视剧配角身份出道，凭借扎实的表演功底与独特的镜头感迅速获得关注。早期作品多为青春与校园题材，她在其中塑造了一系列明亮而真实的少女形象。',
    '2019年起，她开始有意识地向更具挑战性的角色转型，先后出演都市家庭剧与文艺电影，逐渐摆脱偶像标签。业内评价她「擅长在沉默中积蓄力量」。',
    '2023年后，夏目彩春进入事业的全面爆发期。她在《最后的画师》中完成横跨四十年的表演，在《无声告白》中以无台词演出挑战表演极限，两度获得重量级奖项提名。',
    '近年来，她在选角上愈发注重作品的社会表达与人物深度，并积极参与传统工艺、听障群体等公益议题的推广。她被媒体称为「用作品说话的演员」。',
  ],
  representativeIds: ['zuihou-de-huashi', 'wusheng-gaobai', 'fengqi-changjie', 'xueguo-zhilie-zhiye', 'niguang-erxing'],
  stats: [
    { label: '参演作品', value: '30+' },
    { label: '获奖与提名', value: '12' },
    { label: '出道年数', value: '10' },
    { label: '代表作品', value: '10' },
  ],
};